import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import { apiRequest } from "../../Lib/Utils/ApiRequest";
import { IApiResponse } from "../../Orchestrator/Types/Index";
import { IContactCategoryConfigResponse } from "../../Orchestrator/Types/Interface/ICustomerContact";

export async function getContactCategoriesList(): Promise<
  IApiResponse<IContactCategoryConfigResponse>
> {
  const ENDPOINTS = await getEndpoints();
  return await apiRequest<IContactCategoryConfigResponse>(
    ENDPOINTS.getContactCategories,
    "GET"
  );
}
